module.exports = __webpack_public_path__ + "static/media/HIRN.40817893.jpg";